import axiosClient from "../axiosClient";

export const getGroups = async () => {
    return await axiosClient.get('/get_group_details');
};

export const getRecommendedGroup = async () => {
    return await axiosClient.get('/get_recommended_group');
};

export const addRecommendedGroup = async (data) => {
    return await axiosClient.post(`/add_recommended_group`, data);
};

export const getRecommendedGroupPublic = async () => {
    return await axiosClient.get('/get_free_group');
};

export const addRecommendedGroupPublic = async (data) => {
    return await axiosClient.post(`/add_free_group`, data);
};

export const changeGroupStatus = async (data) => {
    return await axiosClient.put(`/edit_group_status`, data);
};

export const getGroupAttendee = async (data) => {
    return await axiosClient.post(`/get_group_attendee`, data);
};

export const editGroup = async (data) => {
    return await axiosClient.put(`/edit_group`, data);
};

export const deleteGroup = async (data) => {
    return await axiosClient.post(`/delete_admin_group`, data);
};

export const discussionAllGroup = async (id) => {
    return await axiosClient.get(`/get_group_discussion/${id}`);
};

export const discussionDeleteGroup = async (id) => {
    return await axiosClient.delete(`/delete_group_discussion_post/${id}`);
};